import { Tracer, ExplicitContext, ConsoleRecorder, BatchRecorder, jsonEncoder } from 'zipkin';
import wrapFetch from 'zipkin-instrumentation-fetch';
import { HttpLogger } from 'zipkin-transport-http';
import { getConfigValue } from '@jutro/config';
import { REQUEST_HANDLER_TYPE } from '../HttpRequestBuilder';
const wrapWindowFetch = wrapFetch;
const JSON_V2 = jsonEncoder.JSON_V2;
export function zipkinTraceHandler(remoteServiceName, localServiceName, zipkinUrl, debug, fetchCall = globalThis.fetch) {
  let recorder;
  const zipkinDebugConfigValue = getConfigValue('zipkinDebug');
  const zipkinUrlConfigValue = getConfigValue('JUTRO_ZIPKIN_URL');
  if (debug || zipkinDebugConfigValue) {
    recorder = new ConsoleRecorder();
  } else if (zipkinUrl || zipkinUrlConfigValue) {
    recorder = new BatchRecorder({
      logger: new HttpLogger({
        endpoint: zipkinUrl || (zipkinUrlConfigValue === null || zipkinUrlConfigValue === void 0 ? void 0 : zipkinUrlConfigValue.toString()),
        jsonEncoder: JSON_V2
      })
    });
  } else {
    recorder = {
      record: () => {}
    };
  }
  const zipkinLocalServiceNameConfigValue = getConfigValue('JUTRO_ZIPKIN_LOCAL_SERVICE_NAME');
  const tracer = new Tracer({
    ctxImpl: new ExplicitContext(),
    recorder,
    localServiceName: localServiceName || (zipkinLocalServiceNameConfigValue === null || zipkinLocalServiceNameConfigValue === void 0 ? void 0 : zipkinLocalServiceNameConfigValue.toString())
  });
  const traceFetch = (url, options, theFetch = fetchCall) => {
    return wrapWindowFetch(theFetch, {
      tracer,
      remoteServiceName
    })(url, options);
  };
  return {
    [REQUEST_HANDLER_TYPE.FETCH]: traceFetch
  };
}